import {ISubmissionProps} from '../../resources/submission';

const columns: any = {
    '1': 0,
    '2': 33,
    '3': 67,
    '4': 100,
}

export const getIndicators = (submissions: ISubmissionProps[]) => {
    let value = 0;

    submissions.forEach(submission => {
        const submissionValues = {
            total: 0,
            sum: 0,
        }

        Object.entries(submission)
            .forEach(([question, value]) => {
                if (question.startsWith('domanda13_row') && typeof value === 'string') {
                    submissionValues.sum += columns[value.trim()];
                    submissionValues.total++;
                }
            });

        value += submissionValues.sum / submissionValues.total;
    })

    if (submissions.length > 0) {
        return Number((value / submissions.length).toFixed(2));
    }

    return 0;
}